<div tid="entity-screen" (window:resize)="onResize($event)" class="container">
    <div *ngIf="isPrepareDataReady" class="item-header">
        <entity-header [config]="entityConfig"></entity-header>
    </div>
    <div *ngIf="!isPrepareDataReady" class="screen-loading-spin" loading-spin [isLoading]="isEntityScreenLoading"
        [loadingSize]="'big'"></div>
    <div class="item-tab-body" *ngIf="isPrepareDataReady">
        <div class="panel-tab">
            <tam-tab-set tid="entity_screen_tabs" [selectedIndex]="selectedIndex"
                (selectChange)="onTabSelectChange($event)" [draggable]="draggableTab"
                (editTitle)="onTabTitleBlur($event)" (reSortTab)="onTabSort($event)">
                <tam-tab *ngFor="let item of pages; trackBy:trackByFn" [title]="item.name" [editable]="item.editable"
                    [editing]="item.editing" (contextmenu)="showPageContextMenu($event,item)">
                </tam-tab>
                <ng-template #extra>
                    <div class="extra_add">
                        <smart-icon tid="add_icon" name="add" class="light" (click)=showPagesContextMenu($event,item)>
                        </smart-icon>
                    </div>
                </ng-template>
            </tam-tab-set>
        </div>
        <div class="page-box" *ngFor="let page of pages;trackBy:trackByFn"
            [style.display]="page.id===currentPageId?'block':'none'">
            <div class="screen-container">
                <div class="research-container" *ngIf="page.screenType==='research'&&page.config">
                    <research-screen [config]="page.config"></research-screen>
                </div>
                <div class="dashboard-container" *ngIf="page.screenType==='dashboard'" loading-spin
                    [isLoading]="reloadingDashboard" [loadingSize]="'big'">
                    <dashboard-screen [screenKey]="page.screenId" [storeKey]="page.id" [screenType]="page.screenType"
                        [loadingSpecificScreen]="loadingSpecificScreen" [firstPageTabId]="firstTabPageId"
                        [actionSubject$]="actionSubject$" [pageType]="'entityScreen'">
                    </dashboard-screen>
                </div>
                <div class="event-container" *ngIf="page.id===currentPageId&&page.screenType==='event'&&page.config">
                    <calendar-screen [config]="page.config" [entityID]="entityConfig.entity.id"></calendar-screen>
                </div>
                <div class="panel-info"
                    *ngIf="page.id===currentPageId&&(page.screenId===entityDetailScreenId||page.screenId===relationshipScreenId)">
                    <div *ngIf="!(isSmallScreenSize&&page.screenId===relationshipScreenId)"
                        class="panel-left panel-left-height">
                        <div tid="entity_body" class="item-body">
                            <entity-body [config]="entityConfig"></entity-body>
                        </div>
                    </div>
                    <div class="panel-right panel-right-height"
                        *ngIf="!(isSmallScreenSize&&page.screenId===entityDetailScreenId)">
                        <div *ngIf="isRelationshipLoading" class="screen-loading-spin" loading-spin
                            [loadingSize]="'big'" [isLoading]="isRelationshipLoading">
                        </div>
                        <div class="item-relationships" tid="entity_relationships" *ngIf="!isRelationshipLoading">
                            <relationship-tree [config]="relationshipTreeConfig"></relationship-tree>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <tam-context-menu [config]="contextMenuConfig"></tam-context-menu>
    <context-menu #screensMenu>
        <ng-container *ngFor="let menu of this.screenMenuContainer;trackBy:trackByFn">
            <context-menu #screenSubMenu>
                <ng-template contextMenuItem *ngFor="let subMenu of menu.items;trackBy:trackByFn"
                    (execute)="onAddScreen(subMenu)">
                    <div class="screen-sub-menu-container">
                        <span [title]="subMenu.caption">{{subMenu.caption}}</span>
                    </div>
                </ng-template>
            </context-menu>
            <ng-template contextMenuItem let-item [subMenu]="menu.type && screenSubMenu">
                <div class="screen-menu-item-container">
                    <div class="screen-menu-item">
                        <smart-icon [name]="menu.iconName" class="menu-item-icon"></smart-icon>
                        <span>{{menu.caption}}</span>
                    </div>
                    <smart-icon name="angle-right"></smart-icon>
                </div>
            </ng-template>
        </ng-container>
        <ng-template contextMenuItem divider="true"></ng-template>
    </context-menu>
</div>